import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconSelectedStore = props => {
  if (props.id !== "_svgiconselectedstore") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path d="M35.783 11.75H12.217c-1.326 0-2.217.904-2.217 2.249v4.024c0 .986.565 1.783 1.4 2.1v14.115c0 1.26.872 2.012 2.333 2.012h1.4V24.39c0-1.31.873-2.225 2.123-2.225H30.6c1.334 0 2.267.884 2.267 2.15V36.25h1.75c1.427 0 1.983-.548 1.983-1.953V20.123c.835-.317 1.4-1.114 1.4-2.1V13.88c0-1.314-.85-2.13-2.217-2.13zm.817 6.273c0 .496-.328.828-.817.828H12.217c-.489 0-.817-.332-.817-.828v-4.024c0-.558.267-.829.817-.829h23.566c.754 0 .817.351.817.71v4.143zm-20.133 6.135v13.285h7V23.258h-6.253c-.65 0-.747.564-.747.9zm14.436-.9H24.8v14.185h7V24.075c0-.676-.488-.817-.897-.817z" fill="#384048" /></g></svg>;
};

SvgIconSelectedStore.displayName = "_svgiconselectedstore";
SvgIconSelectedStore.propTypes = {
  id: PropTypes.string
};
SvgIconSelectedStore.defaultProps = {
  id: ''
};
export default SvgIconSelectedStore;